import { Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import Style from './style';
import Frame from '../frame';
import { periods } from '../../sections/information-contributions/helper';
import Overview from '../overview';
import { getPopupContainer } from '../../../../../../../helpers/popUp';
import { DashboardService } from '../../../../../../../services';
import DashboardPopover from '../../../../../../../components/dashboards/components/Popover';

const Contributors = ({
  t = (s) => s,
  valToResetFilters,
  canFetch = false,
  settings,
}) => {
  const [data, setData] = useState(null);
  const [frameActions, setFrameActions] = useState(null);
  const mounted = useRef(true);
  const [activeFilter, setActiveFilter] = useState(
    settings?.defaultFilters?.correctiveActionPlans || 'year'
  );

  useEffect(() => {
    if (settings?.defaultFilters?.correctiveActionPlans) {
      setActiveFilter(settings?.defaultFilters?.correctiveActionPlans);
    }
  }, [settings]);

  useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const _fetch = async () => {
    try {
      if (mounted.current) {
        setData(null);
        const res = await DashboardService.getPmeProject({
          widget: 'recommendations',
          secondWidget: 'recommendationsOverview',
          filters: {
            periods: activeFilter,
          }
        })
        if (res.data?.recommendationsOverview) {
          if (mounted.current) {
            setData(res.data?.recommendationsOverview);
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    if (canFetch && mounted.current) {
      _fetch();
    }
  }, [activeFilter, canFetch, valToResetFilters]);

  useEffect(() => {
    if (mounted.current) {
      if (frameActions) {
        if (!data) {
          frameActions.loading(true);
        } else {
          frameActions.loading(false);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [frameActions, data]);

  return (
    <Frame
      onInit={actions => setFrameActions(actions)}
      title={t('Corrective Action Plans')}
      optionalHeaderContent={(
        <Select
          {...getPopupContainer()}
          style={{ width: 100 }}
          className='custom-select'
          value={activeFilter}
          onChange={(val) => setActiveFilter(val)}
        >
          {periods.map((v, i) => (
            <Select.Option
              value={v.value}
              key={`key-tasks-${i}-${v.value}`}
            >
              {t(v.label)}
            </Select.Option>
          ))}
        </Select>
      )}
      tooltip={(
        <DashboardPopover
          title={t('Corrective Action Plans')}
          body={t('Overview of recommendations for the selected area, as consolidated from all selected information sources.')}
        />
      )}
    >
      <Style>
        {!!data && (
          <Overview t={t} data={data} />
        )}
      </Style>
    </Frame>
  );
};

export default Contributors;
